import { StyledSearchBar, useDebouncedSearch } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { useRecoilState } from 'recoil';
import { searchDeliveryFenceState } from '../../storage/deliveryFences';

function DeliveryDenceFilters() {
  const { search, setSearch } = useDebouncedSearch(useRecoilState(searchDeliveryFenceState));

  return (
    <StyledSearchBar
      name="delivery-fence-search"
      value={search}
      onChange={(value) => setSearch(value)}
      clearable
      noMargin
    />
  );
}

export default memo(DeliveryDenceFilters);
